import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { BOOKING_STATUSES } from '@greenostrov/shared';
import type { BookingStatus } from '@greenostrov/shared';
import { api } from '../lib/api';
import { BOOKING_STATUS_LABELS } from '../lib/labels';
import type { BookingRow } from '../lib/types';

export function BookingsPage() {
  const [status, setStatus] = useState<string>('');
  const [q, setQ] = useState('');
  const [debouncedQ, setDebouncedQ] = useState('');

  const list = useQuery({
    queryKey: ['bookings', status, debouncedQ],
    queryFn: () =>
      api.listBookings({
        ...(status ? { status } : {}),
        ...(debouncedQ ? { q: debouncedQ } : {}),
        limit: 50,
      }),
  });

  return (
    <div>
      <h1 style={{ fontSize: 24, marginBottom: 4 }}>Заявки</h1>
      <p style={{ color: 'var(--text-muted)', marginBottom: 20 }}>
        Всего: {list.data?.total ?? '—'}
      </p>

      <div style={{ display: 'flex', gap: 10, marginBottom: 18, flexWrap: 'wrap' }}>
        <select className="select" value={status} onChange={(e) => setStatus(e.target.value)} style={{ maxWidth: 200 }}>
          <option value="">Все статусы</option>
          {BOOKING_STATUSES.map((s) => (
            <option key={s} value={s}>
              {BOOKING_STATUS_LABELS[s]}
            </option>
          ))}
        </select>
        <form
          style={{ flex: 1, minWidth: 220 }}
          onSubmit={(e) => {
            e.preventDefault();
            setDebouncedQ(q);
          }}
        >
          <input
            className="input"
            placeholder="Поиск по имени, телефону, email"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onBlur={() => setDebouncedQ(q)}
          />
        </form>
      </div>

      {list.isLoading && <div style={{ color: 'var(--text-muted)' }}>Загрузка…</div>}
      {list.error && <div className="error">Ошибка загрузки: {(list.error as Error).message}</div>}

      <div style={{ display: 'grid', gap: 10 }}>
        {list.data?.items.map((raw) => {
          const b = raw as BookingRow;
          return (
            <Link
              key={b.id}
              to={`/bookings/${b.id}`}
              className="card"
              style={{ padding: 14, display: 'grid', gridTemplateColumns: '1fr auto', gap: 10, alignItems: 'center' }}
            >
              <div style={{ minWidth: 0 }}>
                <div style={{ fontWeight: 600, marginBottom: 2 }}>
                  {b.name} <span style={{ color: 'var(--text-muted)', fontWeight: 400 }}>· {b.phone}</span>
                </div>
                <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>
                  {b.accommodationType ?? 'любая категория'} ·{' '}
                  {b.checkin && b.checkout ? `${b.checkin} → ${b.checkout}` : 'даты не указаны'} ·{' '}
                  {b.guests ?? '?'} гостей
                </div>
                <div style={{ fontSize: 12, color: 'var(--text-soft)', marginTop: 2 }}>
                  {new Date(b.createdAt).toLocaleString('ru')}
                </div>
              </div>
              <span className={`badge badge-${b.status}`}>{BOOKING_STATUS_LABELS[b.status as BookingStatus]}</span>
            </Link>
          );
        })}
        {list.data && list.data.items.length === 0 && (
          <div style={{ color: 'var(--text-muted)', padding: 20, textAlign: 'center' }}>
            Ничего не найдено
          </div>
        )}
      </div>
    </div>
  );
}
